import promise from 'bluebird'
import { voucherConstants } from '../_constants/voucherConstants';
import { voucherService } from "../_services";

export const voucherActions = {
    // Catalog operations
    getVoucherCatalogs,
    selectVoucher,
    selectedVoucherList,
    
    // Instance operations
    getVoucherInstances,
    getVoucherByCode,
    getVoucherByRedemptionCode,
    updateVoucherBalance,
    
    // New operations
    issueVoucher,
    redeemVoucher,
    voidVoucher,
    updateVoucherRedemption
};

/**
 * Get all vouchers
 * @returns {Function} Thunk function
 */
function getVoucherCatalogs() {
    return function (dispatch) {
        dispatch({ type: voucherConstants.GET_VOUCHERS });
        
        return new Promise(function (resolve, reject) {
            voucherService.listVoucherCatalogs()
                .then(response => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHERS_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHERS_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Get all voucher instances
 * @param {Object} filters - Optional filters
 * @returns {Function} Thunk function
 */
function getVoucherInstances(filters = {}) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.GET_VOUCHERS });
        
        return new Promise(function (resolve, reject) {
            voucherService.listVoucherInstances(filters)
                .then(response => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHERS_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHERS_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Select a single voucher
 * @param {Object} data - Voucher data
 * @returns {Function} Thunk function
 */
function selectVoucher(data) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.SELECT_VOUCHER, data })
    };
}

/**
 * Set the selected voucher list
 * @param {Array} data - List of selected vouchers
 * @returns {Function} Thunk function
 */
function selectedVoucherList(data) {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            resolve(dispatch({ type: voucherConstants.SELECTED_VOUCHER_LIST, data }))
        })
    };
}

/**
 * Get a voucher by code
 * @param {String} code - Voucher code
 * @returns {Function} Thunk function
 */
function getVoucherByCode(code) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.GET_VOUCHER_BY_CODE });
        
        return new Promise(function (resolve, reject) {
            voucherService.getVoucherInstanceByCode(code)
                .then(response => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHER_BY_CODE_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHER_BY_CODE_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Update voucher balance
 * @param {String} voucherId - Voucher ID
 * @param {Number} remainingValue - New remaining value
 * @returns {Function} Thunk function
 */
function updateVoucherBalance(voucherId, remainingValue) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.UPDATE_VOUCHER_BALANCE });
        
        return new Promise(function (resolve, reject) {
            voucherService.updateVoucherBalance(voucherId, remainingValue)
                .then(response => {
                    dispatch({
                        type: voucherConstants.UPDATE_VOUCHER_BALANCE_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.UPDATE_VOUCHER_BALANCE_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Issue a new voucher
 * @param {Object} params - Parameters for issuing a voucher
 * @returns {Function} Thunk function
 */
function issueVoucher(params) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.ISSUE_VOUCHER });
        
        return new Promise(function (resolve, reject) {
            voucherService.issueVoucher(params)
                .then(response => {
                    dispatch({
                        type: voucherConstants.ISSUE_VOUCHER_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.ISSUE_VOUCHER_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Redeem a voucher
 * @param {Object} params - Parameters for redeeming a voucher
 * @returns {Function} Thunk function
 */
function redeemVoucher(params) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.REDEEM_VOUCHER });
        
        return new Promise(function (resolve, reject) {
            voucherService.redeemVoucher(params)
                .then(response => {
                    dispatch({
                        type: voucherConstants.REDEEM_VOUCHER_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.REDEEM_VOUCHER_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Void a voucher
 * @param {String} voucherId - Voucher ID
 * @returns {Function} Thunk function
 */
function voidVoucher(voucherId) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.VOID_VOUCHER });
        
        return new Promise(function (resolve, reject) {
            voucherService.voidVoucherInstance(voucherId)
                .then(response => {
                    dispatch({
                        type: voucherConstants.VOID_VOUCHER_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.VOID_VOUCHER_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Update a voucher redemption with a booking ID
 * @param {String} voucherId - Voucher ID
 * @param {Number} redemptionIndex - Index of the redemption to update
 * @param {String} bookingId - Booking ID to associate with the redemption
 * @returns {Function} Thunk function
 */
function updateVoucherRedemption(voucherId, redemptionIndex, bookingId) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.UPDATE_VOUCHER_REDEMPTION });
        
        return new Promise(function (resolve, reject) {
            voucherService.updateVoucherRedemption(voucherId, redemptionIndex, bookingId)
                .then(response => {
                    dispatch({
                        type: voucherConstants.UPDATE_VOUCHER_REDEMPTION_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.UPDATE_VOUCHER_REDEMPTION_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}

/**
 * Get a voucher by redemption code
 * @param {String} redemptionCode - Voucher redemption code
 * @returns {Function} Thunk function
 */
function getVoucherByRedemptionCode(redemptionCode) {
    return function (dispatch) {
        dispatch({ type: voucherConstants.GET_VOUCHER_BY_REDEMPTION_CODE });
        
        return new Promise(function (resolve, reject) {
            voucherService.getVoucherByRedemptionCode(redemptionCode)
                .then(response => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHER_BY_REDEMPTION_CODE_SUCCESS,
                        data: response.data
                    });
                    resolve(response);
                })
                .catch((err) => {
                    dispatch({
                        type: voucherConstants.GET_VOUCHER_BY_REDEMPTION_CODE_FAILURE,
                        error: err
                    });
                    reject(err);
                })
        })
    };
}